import type { FaireProductEntity } from "../../entity_types/product";

export const p_3qd3nwrrge: FaireProductEntity = {
  token: "p_3qd3nwrrge",
  type: "product",
  name: "Tomato-do List Food-Shaped Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/89549eea1dc3b3558d7286efe13e4de6cede49473bc35bc46e1bd83e7fdeda76.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b921a4bad792fd2a568c27edb71a6c2d19dd4b89dd7e88077ea1d268b4a4fb3.jpeg"
  ],
  priceDollars: 5,
  description: "Serve up grocery lists, recipes, memos & more with our Tomato-do List Sticky Notes. This die-cut, tomato-shaped pad features 50 writable, stickable sheets—perfect for staying organized, jotting reminders, leaving lunch notes, or bookmarking your favorite cookbooks.\n\nGood to know:\n\n * Stick & restick anywhere \n * Thick sticky pad with 50 sheets \n * Measures roughly 3\"x3\" \n * Packaged on a thick backing card and wrapped in a cellophane sleeve. \n * 100% recyclable 🍅 ",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:09.683Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
